<template>
  <div class="navigation-links">
      <router-link v-if="surroundings.prev" class="previous"
        :to="{
          query: { ...$route.query, [`level${lastLevel}`]: surroundings.prev },
        }"
        ><span class="visuallyhidden">{{ labels.SEN_GUIDA_TOPIC }}</span> {{ labels.SEN_GUIDA_TOPIC_PREVIOUS }}</router-link
      >
      <router-link v-if="surroundings.next" class="next"
        :to="{
          query: { ...$route.query, [`level${lastLevel}`]: surroundings.next },
        }"
        ><span class="visuallyhidden">{{ labels.SEN_GUIDA_TOPIC }}</span> {{ labels.SEN_GUIDA_TOPIC_NEXT }}</router-link
      >
  </div>
</template>
<script>
import content from "@/data/content";
import labels from "@/data/labels.json";

export default {
  data() {
    return {
      labels,
    };
  },
  computed: {
    surroundings() {
      return Object.values(this.$route.query).reduce((prev, curr, index) => {
        let currentLevel = prev[`level${index + 1}`];
        if (index + 1 != Object.values(this.$route.query).length) {
          return currentLevel[curr];
        } else {
          let indexSelected = Object.keys(currentLevel).indexOf(curr);
          return {
            prev: Object.keys(currentLevel)[indexSelected - 1] ?? false,
            next: Object.keys(currentLevel)[indexSelected + 1] ?? false,
          };
        }
      }, content);
    },
    lastLevel() {
      return Object.keys(this.$route.query).length;
    },
  },
};
</script>
